<div tabindex="0" class="me-sr-difficulties row" *ngIf="data">
    <div class="me-sr-difficulties__content col-sm-12 col-md-4">
        <div class="me-sr-difficulties__content__header">
            {{data.headline}}
        </div>
    </div>
    <div class="me-sr-difficulties__form col-sm-12 col-md-8">
        <div class="me-sr-difficulties__form__textarea me-form-input">
            <textarea maxlength="600"
                      required="required"
                      placeholder="{{data.form[0]['placeholder']}}"
                      class="w-100"
                      [(ngModel)]="text"></textarea>
        </div>

        <div class="me-sr-difficulties__form__button">
            <button class="btn btn--primary" [ngClass]="text.length > 0 ? ' btn-active-me' : ''" (click)="next()">
                <ng-container *ngIf="text.length === 0">
                    {{ 'Skip' | translate}}
                </ng-container>
                <ng-container *ngIf="text.length > 0">
                    {{ 'Continue' | translate}}
                </ng-container>
            </button>
        </div>
    </div>
</div>